import api from "../../../utils/api"

export const getAllDashboardCount = async() => {
  try {
    const res = await api.get('user/getUserCountForadmin');
    return res;
  } catch (err) {
    return err;
  }
}


export const getMarketplaceJobsData = async (page, limit, search, userid, status) => {
  try {
    const res = await api.get(
      `${process.env.REACT_APP_BASE_MARKETPLACE_URL_NEW}api/market-place-jobs/get/dashboardDetails?page=${page}&limit=${limit}&search=${search || ""}&user_id=${userid}${status ? `&status=${status}` : ""}&jobVisibilityFor=cms`,
    );
    return res;
  } catch (err) {
    return err;
  }
};

export const addResumeInJobs = async (jobId, resumeFiles, jobName) => {   
  try {     
    const formData = new FormData();
    
    if (Array.isArray(resumeFiles)) {
      resumeFiles.forEach((file, index) => {
        formData.append('files', file);
      });
    } else {
      formData.append('files', resumeFiles);
    }
    
    formData.append('jobId', jobId.toString());
    if (jobName) {
      formData.append('jobName', jobName);
    }
    
    for (let [key, value] of formData.entries()) {
      console.log(key, value);
    }
    
    const res = await api.post(       
      `${process.env.REACT_APP_MOCK_RESUME_URL}/resume-processor/process`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );     
    return res;   
  } catch (err) {     
    console.error('API Error:', err);
    throw err;   
  } 
};
export const closeMarketplaceJob = async (jobId) => {
  try {
    const res = await api.patch(
      `${process.env.REACT_APP_BASE_MARKETPLACE_URL_NEW}api/market-place-jobs/admin/updatejob/${jobId}`,
      {
        status: "CLOSED"
      }
    );
    return res;
  } catch (err) {
    return err;
  }
};